<template>
  <div class="app-search-field">
    <button class="button basic" @click="onClickSearchIconButton">
      <AppIcon name="search" />
    </button>
    <TextField
      v-model="keyword"
      :placeholder="placeholder"
      @keydown.enter="onKeyDownSearchField"
      ref="searchField"
      @input="onInputSearchField"
    />
  </div>
</template>

<script>
import { defineComponent } from 'vue';
import { mapGetters, mapMutations, mapActions } from 'vuex';
import AppIcon from '@/app/components/app-icon';
import TextField from '@/app/components/text-field';
import { debounce } from 'debounce';

export default defineComponent({
  name: 'AppSearchField',

  /**
   * 属性
   */
  props: {},

  /**
   * 数据
   */
  data() {
    return {};
  },

  /**
   * 计算属性
   */
  computed: {
    ...mapGetters({
      searchOption: 'search/searchOption',
      searchKeyword: 'search/searchKeyword',
    }),

    keyword: {
      get() {
        return this.searchKeyword;
      },

      set(value) {
        this.setSearchKeyword(value);

        if (!value) {
          this.setSearchResults(null);
        }
      },
    },

    placeholder() {
      return `搜索${this.searchOption.title}`;
    },
  },

  /**
   * 已创建
   */
  created() {
    //
  },

  /**
   * 已挂载
   */
  mounted() {
    this.focusSearchField();
  },

  /**
   * 监视
   */
  watch: {
    searchOption() {
      this.focusSearchField();
    },
  },

  /**
   * 组件方法
   */
  methods: {
    ...mapMutations({
      setSearchKeyword: 'search/setSearchKeyword',
      setSearchResults: 'search/setSearchResults',
    }),

    ...mapActions({
      search: 'search/search',
      pushMessage: 'notification/pushMessage',
    }),

    async submitSearch() {
      const response = await this.search();

      if (!response.data.length) {
        this.pushMessage({ content: `没找到相关${this.searchOption.title}` });
      }
    },

    onClickSearchIconButton() {
      this.submitSearch();
    },

    onKeyDownSearchField() {
      this.submitSearch();
    },

    focusSearchField() {
      this.$refs.searchField.$el.querySelector('input').focus();
    },

    debounceSearch: debounce(function() {
      this.search();
    }, 500),

    onInputSearchField(event) {
      const keyword = event.target.value.trim();

      if (keyword.length >= 2) {
        this.debounceSearch();
      }
    },
  },

  /**
   * 使用组件
   */
  components: {
    AppIcon,
    TextField,
  },
});
</script>

<style scoped>
@import './styles/app-search-field.css';
</style>
